import {
  CH_PP_RATING_EXCELLENT,
  CH_PP_RATING_FAIR,
  CH_PP_RATING_GOOD,
  CH_PP_RATING_NEUTRAL,
  CH_PP_RATING_POOR,
  CH_PP_RATING_VERY_GOOD
} from "../constants";

/**
 * Converts a PerformanceRating to the class that should be used for the table cell
 * @param {PerformanceRating} rating
 * @returns {string}
 */
export function ratingToClass(rating) {
  switch (rating) {
    case CH_PP_RATING_EXCELLENT:
      return "excellent";
    case CH_PP_RATING_VERY_GOOD:
      return "very-good";
    case CH_PP_RATING_GOOD:
      return "good";
    case CH_PP_RATING_FAIR:
      return "fair";
    case CH_PP_RATING_POOR:
      return "poor";
    case CH_PP_RATING_NEUTRAL:
      return "neutral";
  }
}

/**
 * Converts a PerformanceRating to a numerical rating (higher is better)
 * @param {PerformanceRating} rating
 * @returns {number}
 */
export function ratingToNumber(rating) {
  switch (rating) {
    case CH_PP_RATING_EXCELLENT:
      return 5;
    case CH_PP_RATING_VERY_GOOD:
      return 4;
    case CH_PP_RATING_GOOD:
      return 3;
    case CH_PP_RATING_FAIR:
      return 2;
    case CH_PP_RATING_POOR:
      return 1;
    case CH_PP_RATING_NEUTRAL:
      return 0;
  }
}

/**
 * Sort function generator for Performance Ratings
 * @param {string} key
 * @param {"asc" | "desc"} dir
 * @returns {function(ContractHolderPerformanceRating, ContractHolderPerformanceRating): -1 | 0 | 1}
 */
export function ratingSort(key, dir) {
  return (rating1, rating2) => {
    rating1 = ratingToNumber(rating1[key]);
    rating2 = ratingToNumber(rating2[key]);
    if (dir === "asc") {
      if (rating1 === 0) {
        return 1;
      } else if (rating2 === 0) {
        return -1;
      } else if (rating1 > rating2) {
        return -1;
      } else if (rating1 < rating2) {
        return 1;
      } else {
        return 0;
      }
    } else if (dir === "desc") {
      if (rating1 === 0) {
        return 1;
      } else if (rating2 === 0) {
        return -1;
      } else if (rating1 > rating2) {
        return 1;
      } else if (rating1 < rating2) {
        return -1;
      } else {
        return 0;
      }
    }

  };
}